package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.PrescriptionCategory
import com.jingfangpai.common.orm.mapping.enums.PrescriptionSubCategory
import com.jingfangpai.common.orm.mapping.enums.PrescriptionStatus
import com.jingfangpai.common.orm.mapping.enums.PrescriptionOwnerType
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer
import com.jingfangpai.common.orm.mapping.enums.PrescriptionApplicableSyndromeClassic
import kotlin.collections.Set
import com.jingfangpai.common.orm.mapping.enums.PrescriptionApplicableSyndromeViscus

@Serializable
open class Prescription(var id: String? = null){
	var name: String? = null
	var source: String? = null
	var category: PrescriptionCategory? = null
	var subCategory: PrescriptionSubCategory? = null
	var composition: String? = null
	var administration: String? = null
	var actions: String? = null
	var indications: String? = null
	var contraindication: String? = null
	var formulaAnalysis: String? = null
	var applications: String? = null
	var keySignSymptoms: String? = null
	var differentiation: String? = null
	var description: String? = null
	var status: PrescriptionStatus? = null
	var weight: Int? = null
	var ownerType: PrescriptionOwnerType? = null
	var ownerId: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null
	var createdBy: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var timestamp: DateTime? = null
	var applicableSyndromeClassic: Set<PrescriptionApplicableSyndromeClassic>? = null
	var applicableSyndromeViscus: Set<PrescriptionApplicableSyndromeViscus>? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as Prescription
		if (id != other.id) return false
		if (name != other.name) return false
		if (source != other.source) return false
		if (category != other.category) return false
		if (subCategory != other.subCategory) return false
		if (composition != other.composition) return false
		if (administration != other.administration) return false
		if (actions != other.actions) return false
		if (indications != other.indications) return false
		if (contraindication != other.contraindication) return false
		if (formulaAnalysis != other.formulaAnalysis) return false
		if (applications != other.applications) return false
		if (keySignSymptoms != other.keySignSymptoms) return false
		if (differentiation != other.differentiation) return false
		if (description != other.description) return false
		if (status != other.status) return false
		if (weight != other.weight) return false
		if (ownerType != other.ownerType) return false
		if (ownerId != other.ownerId) return false
		if (createdOn != other.createdOn) return false
		if (createdBy != other.createdBy) return false
		if (timestamp != other.timestamp) return false
		if (applicableSyndromeClassic != other.applicableSyndromeClassic) return false
		if (applicableSyndromeViscus != other.applicableSyndromeViscus) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (name?.hashCode() ?: 0)
		result = 31 * result + (source?.hashCode() ?: 0)
		result = 31 * result + (category?.hashCode() ?: 0)
		result = 31 * result + (subCategory?.hashCode() ?: 0)
		result = 31 * result + (composition?.hashCode() ?: 0)
		result = 31 * result + (administration?.hashCode() ?: 0)
		result = 31 * result + (actions?.hashCode() ?: 0)
		result = 31 * result + (indications?.hashCode() ?: 0)
		result = 31 * result + (contraindication?.hashCode() ?: 0)
		result = 31 * result + (formulaAnalysis?.hashCode() ?: 0)
		result = 31 * result + (applications?.hashCode() ?: 0)
		result = 31 * result + (keySignSymptoms?.hashCode() ?: 0)
		result = 31 * result + (differentiation?.hashCode() ?: 0)
		result = 31 * result + (description?.hashCode() ?: 0)
		result = 31 * result + (status?.hashCode() ?: 0)
		result = 31 * result + (weight?.hashCode() ?: 0)
		result = 31 * result + (ownerType?.hashCode() ?: 0)
		result = 31 * result + (ownerId?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (timestamp?.hashCode() ?: 0)
		result = 31 * result + (applicableSyndromeClassic?.hashCode() ?: 0)
		result = 31 * result + (applicableSyndromeViscus?.hashCode() ?: 0)
		return result
	}

}
